import React, { useMemo, useRef } from 'react';

const DefaultType = ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'doc', 'docx', 'csv', 'xlsx', 'xls', 'txt'];
const AcceptMap = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    csv: 'text/csv',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls: 'application/vnd.ms-excel',
    txt: 'text/plain'
};

const Upload = (props) => {
    const { type = DefaultType, children, onChange, className } = props;

    const accept = useMemo(() => type.map((key) => AcceptMap[key]).join(','), [type]);

    const fileRef = useRef();
    const onChangeFile = () => {
        if (fileRef.current.files[0]) {
            onChange?.(fileRef.current.files[0]);
        }
        fileRef.current.value = '';
    };

    return (
        <span onClick={() => fileRef.current.click()} className={className ?? ''}>
            <input
                ref={fileRef}
                type="file"
                accept={accept}
                onChange={onChangeFile}
                className="hidden"
            />
            {children}
        </span>
    );
};

export default Upload;
